import React, { Component } from "react";
import "./DegreeCard.css";
import { Fade, Flip } from "react-reveal";

class DegreeCard extends Component {
  render() {
    const degree = this.props.degree;
    const theme = this.props.theme;
    const isDark = this.props.isDark || false;

    // Use dark-mode-friendly logo variants when available
    let logoPath = degree.logo_path;
    // Always use the clean SVG for SSN (both themes — it's a clean vector)
    if (degree.logo_path === "SSN_transparent.png") {
      logoPath = "SSN_clean.svg";
    }
    // Use the square seal for SBU (perfect for circular crop)
    if (degree.logo_path === "SBU_transparent.png") {
      logoPath = "SBU_seal.png";
    }

    return (
      <div className="degree-card">
        {logoPath && (
          <Flip left duration={2000}>
            <div
              className="card-img"
              style={{
                backgroundColor: isDark ? "#1C1C1C" : "#FFFFFF",
                borderColor: isDark ? "#333333" : "#d9dbdf",
                boxShadow: isDark
                  ? "0 4px 12px rgba(0,0,0,0.3)"
                  : "0 4px 12px rgba(0,0,0,0.06)",
              }}
            >
              <img
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                }}
                src={require(`../../assets/images/${logoPath}`)}
                alt={degree.alt_name}
              />
            </div>
          </Flip>
        )}
        <Fade right duration={2000} distance="40px">
          <div
            className="card-body"
            style={{
              width: degree.logo_path ? "90%" : "100%",
              backgroundColor: isDark ? "#1C1C1C" : "transparent",
              borderColor: isDark ? "#333333" : "#d9dbdf",
            }}
          >
            <div
              className="body-header"
              style={{ backgroundColor: theme.headerColor }}
            >
              <div className="body-header-title">
                <h2 className="card-title" style={{ color: theme.text }}>
                  {degree.title}
                </h2>
                <h3
                  className="card-subtitle"
                  style={{ color: theme.secondaryText }}
                >
                  {degree.subtitle}
                </h3>
              </div>
              <div className="body-header-duration">
                <h3 className="duration" style={{ color: theme.secondaryText }}>
                  {degree.duration}
                </h3>
              </div>
            </div>
            <div className="body-content">
              {degree.descriptions.map((sentence, i) => {
                return (
                  <p
                    className="content-list"
                    style={{ color: theme.secondaryText }}
                    key={i}
                  >
                    {sentence}
                  </p>
                );
              })}
              {degree.website_link && (
                <a
                  href={degree.website_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div
                    className="visit-btn"
                    style={{
                      backgroundColor: isDark ? "#2A2A2A" : theme.headerColor,
                      borderColor: theme.imageHighlight,
                    }}
                  >
                    <p className="btn" style={{ color: theme.text }}>
                      Visit Website
                    </p>
                  </div>
                </a>
              )}
            </div>
          </div>
        </Fade>
      </div>
    );
  }
}

export default DegreeCard;
